import { observable, computed, action, toJS } from 'mobx'
import { IScheduleConfig } from '../Model/ScheduleConfig'

export default class ScheduleConfigurationStore {
    @observable
    private scheduleConfigurations: IScheduleConfig[] | null

    @computed
    get getConfig() {
        return toJS(this.scheduleConfigurations)
    }

    @action.bound
    set(data: Array<IScheduleConfig> | null) {
        this.scheduleConfigurations = data
    }

    private static _instance: ScheduleConfigurationStore

    public static getInstance(): ScheduleConfigurationStore {
        return this._instance || (this._instance = new this())
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/ScheduleConfigurationStore.tsx